import { render, staticRenderFns } from "./BillDeleteBulk.vue?vue&type=template&id=10f648bb&"
import script from "./BillDeleteBulk.vue?vue&type=script&lang=js&"
export * from "./BillDeleteBulk.vue?vue&type=script&lang=js&"
import style0 from "./BillDeleteBulk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BillDeleteBulk.vue"
export default component.exports